import { render, staticRenderFns } from "./SelectBoxView.vue?vue&type=template&id=3888ef6c&scoped=true&"
import script from "./SelectBoxView.vue?vue&type=script&lang=js&"
export * from "./SelectBoxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888ef6c",
  null
  
)

export default component.exports